import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3PdfPageSelectionEdit } from "./edit";
import { E3PdfPageSelectionNew } from "./new";
import { E3PdfPageSelectionTable } from "./table";

export default function E3PdfPageSelection() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Sélection de pages PDF");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3PdfPageSelectionEdit />} />
      <Route index element={<E3PdfPageSelectionTable />} />
      <Route path="/new" element={<E3PdfPageSelectionNew />} />
    </Routes>
  );
}
